var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookshelf2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V9.25H19.2349L19.8376 7.0006C19.9091 6.73387 19.7508 6.4597 19.484 6.38823L18.5181 6.12941C18.2514 6.05794 17.9772 6.21623 17.9057 6.48296L17.1643 9.25H16.2349L16.8376 7.0006C16.9091 6.73387 16.7508 6.4597 16.484 6.38823L15.5181 6.12941C15.2514 6.05794 14.9772 6.21623 14.9057 6.48296L14.1643 9.25H3V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.75H3V21.25C3 21.6642 3.33579 22 3.75 22C4.16421 22 4.5 21.6642 4.5 21.25V19H11.25V10.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 19V10.75H21V21.25C21 21.6642 20.6642 22 20.25 22C19.8358 22 19.5 21.6642 19.5 21.25V19H12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelf2);
export default __webpack_public_path__ + "static/media/bookshelf-2.fc8f75bcfc1adafcc074d7134c293de7.svg";
export { ForwardRef as ReactComponent };